const URL_REGEX = new RegExp(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.%]+$/gm);
const URL_WITH_PROTOCOL_REGEX = new RegExp(/^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.%]+$/gm);

export const isURL = (str: string, checkProtocol?: boolean): boolean =>
    Boolean((checkProtocol ? URL_WITH_PROTOCOL_REGEX : URL_REGEX).exec(str));
